import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';


export const customViewSortOptions: OptionsDictionary = {
  'lastAccessedAt': {
    id: 'lastAccessedAt',
    getMenuItemDisplayValue: Messages.sortLastAccessedAt,
    subSortOptions: {
      'asc': {
        id: 'lastAccessedAt.asc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
      },
      'desc': {
        id: 'lastAccessedAt.desc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
      }
    }
  },
  'viewName': {
    id: 'viewName',
    getMenuItemDisplayValue: Messages.sortOriginalView,
    subSortOptions: {
      'asc': {
        id: 'viewName.asc',
        field: OrderKeys.viewName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.viewName)]
      },
      'desc': {
        id: 'viewName.desc',
        field: OrderKeys.viewName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.viewName)]
      }
    }
  },

  'hits': SortOptions.hits,
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'updated': SortOptions.updated,
};
